/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const InSlug: core.serialization.ObjectSchema<serializers.InSlug.Raw, Truvity.InSlug> =
    core.serialization.object({
        values: core.serialization.list(core.serialization.string()),
    });

export declare namespace InSlug {
    export interface Raw {
        values: string[];
    }
}
